'use client';

import React, { Component } from 'react';

import MainTitle from '../reusable-components/layouts-components__garant-fond/main-title';
import Team from '../reusable-components/layouts-components__garant-fond/team';
import Task from '../reusable-components/layouts-components__garant-fond/task';
import History from '../reusable-components/layouts-components__garant-fond/history';
import Process from '../reusable-components/layouts-components__garant-fond/process';
import Results from '../reusable-components/layouts-components__garant-fond/results';

import './style.sass';

import FullWrapper from '../reusable-components/layouts-components__common-cases/full-wrapper';
import NextProject from '../reusable-components/layouts-components__common-cases/next-project';
import { getAdjacentCase } from '../../../../../shared/utilities/GetAdjacentCase/getAdjacentCase';
import About from '../reusable-components/layouts-components__garant-fond/about';
import Tasks from '../reusable-components/layouts-components__garant-fond/tasks';
import Target from '../reusable-components/layouts-components__garant-fond/targeting';
import ScrollAnimation from '../../../../../core/ScrollAnimation';
import OfferButton from '../../../../../shared/sections/OfferButton';
import CommonNav from '../common-components/common-nav';

const mainTitle = {
    titleMainText: 'Контент-маркетинг с гарантией',
    titleAnimation: '/images/pic/garant-fond/main.jpg',
    subText: {
        text: 'В этом кейсе расскажем об особенностях продвижения сообществ клиента из госсектора на основе контент-маркетинга и подключения SEO-инструментов для усиления имиджевого присутствия бренда.',
    },
    subTextNormal: true,
    subtitleContainer: [
        {
            modeText: 'Клиент',
            colorMode: '#597289',
            nameText: 'Гарантийный фонд Ростовской области',
        },
        {
            modeText: 'Отрасль',
            colorMode: '#597289',
            nameText: 'Инфраструктура поддержки МСП',
        },
        {
            modeText: 'Услуги',
            colorMode: '#597289',
            nameText: 'SMM, контент-маркетинг, SEO',
        },
    ],
};

class GarantFond extends Component {
    render() {
        const casePathname = '/cases/marketing/garantiinyi-fond';
        const adjacentCase = getAdjacentCase(casePathname);

        return (
            <section>
                <CommonNav
                    stepOne="Главная"
                    stepTwo="Кейсы"
                    stepThree="Маркетинг"
                    link1={'/'}
                    link2={'/cases'}
                    link3={true}
                />
                <MainTitle
                    MainTitle={mainTitle}
                    classNameTitle="garant-fond__main-title"
                    className="garant-fond-container"
                    classNameText="garant-fond__subtext"
                />
                <History />
                <Task />
                <About />
                <Tasks />
                <Process />
                <Target />
                <Results />

                <Team />

                <ScrollAnimation animateIn="zoomIn" offset={50} animateOnce={true} duration={1}>
                    <FullWrapper>
                        <OfferButton linkText="Нанять команду" />
                    </FullWrapper>
                </ScrollAnimation>

                {adjacentCase && (
                    <NextProject
                        NextProject={{
                            nextProjectTitle: adjacentCase.case.title,
                            nextProjectImg: adjacentCase.case.image,
                            nextProjectLink: adjacentCase.case.router,
                            nextProjectText: adjacentCase.case.description,
                            nextProjectLabel: adjacentCase.label,
                        }}
                    />
                )}
            </section>
        );
    }
}

export default GarantFond;
